import get from 'lodash/get';
import { getVulnId, getVulnValue } from './deleteImpact';

const normalizeId = (id) => {
  if (id === null || typeof id === 'undefined' || id === '') return null;
  return String(id);
};

const getVulnField = (vuln, field, defaultValue = null) => {
  const value = getVulnValue(vuln);
  return get(value, field, get(vuln, field, defaultValue));
};

const flattenLoadedVulns = (vulnsList = []) => {
  return vulnsList.reduce((acc, row) => {
    if (Array.isArray(row?.groupData)) {
      return [...acc, ...row.groupData];
    }

    if (getVulnId(row) != null) {
      return [...acc, row];
    }

    return acc;
  }, []);
};

export const getRemainingGroupVulnsCount = ({
  vulnsList = [],
  explorePayload = null,
  fallbackCount = 0,
  deletedCount = 0,
  selectAll = false
}) => {
  if (selectAll) return 0;

  const apiGroupCount = vulnsList
    .map((vuln) => getVulnField(vuln, 'group_count'))
    .find((count) => typeof count === 'number');
  const payloadGroupCount = explorePayload?.groupVulnsCount;
  let currentGroupCount = fallbackCount;

  if (typeof apiGroupCount === 'number') currentGroupCount = apiGroupCount;
  else if (typeof payloadGroupCount === 'number') currentGroupCount = payloadGroupCount;

  return currentGroupCount - deletedCount;
};

const getExpandedGroupDeletionVulns = (vulnsSelected = [], vulnsList = []) => {
  const loadedVulns = flattenLoadedVulns(vulnsList);
  const lookupVulns = [...loadedVulns, ...vulnsSelected];
  const vulnsById = new Map();
  let isGroupedDeletion = false;

  const addVuln = (vuln) => {
    const vulnId = getVulnId(vuln);
    const vulnKey = normalizeId(vulnId);
    if (vulnKey === null || vulnsById.has(vulnKey)) return;
    vulnsById.set(vulnKey, vuln);
  };

  vulnsSelected.forEach(addVuln);

  vulnsSelected
    .filter((vuln) => Boolean(getVulnField(vuln, 'is_main', false)))
    .forEach((mainVuln) => {
      const headerId = normalizeId(getVulnId(mainVuln));
      const headerGroupId = normalizeId(getVulnField(mainVuln, 'group_id'));
      if (headerId === null) return;

      const belongsToMainGroup = (candidate) => {
        const candidateId = normalizeId(getVulnId(candidate));
        const candidateGroupId = normalizeId(getVulnField(candidate, 'group_id'));
        const candidateGroupVulnId = normalizeId(getVulnField(candidate, 'group_vuln_id'));
        return candidateId === headerId ||
          candidateGroupVulnId === headerId ||
          (headerGroupId !== null && candidateGroupId === headerGroupId);
      };

      const groupMembers = lookupVulns.filter(belongsToMainGroup);

      if (groupMembers.length > 1) isGroupedDeletion = true;

      loadedVulns.filter(belongsToMainGroup).forEach(addVuln);
    });

  const vulns = Array.from(vulnsById.values());
  const ids = vulns.map((vuln) => getVulnId(vuln)).filter((id) => id != null);

  return {
    vulns,
    ids,
    isGroupedDeletion
  };
};

export default getExpandedGroupDeletionVulns;
